<template>
  <div>
    <ejs-dialog
      :animationSettings="{ effect: 'None' }"
      ref="reservationTimeDetailPopup"
      :header="`예약타임 상세 조회`"
      :allowDragging="true"
      :showCloseIcon="true"
      width="950"
      :height="541 + (reservationTrans ? 71 : 0) + (reservationCmpns && reservationCmpns.length > 0 ? 167 : 0) + (reservationAddedInfo ? 119 : 0)"
      :isModal="true"
      :close="onReservationTimeDetailPopupClosed"
    >
      <div class="window reservationTimeDetailSearch">
        <div class="windowContent">
          <div class="content-wrapper">
            <div class="content-body">
              <article class="body-article">
                <!-- 아코디언 : accordion / 닫힘 : close -->
                <section class="article-section section-01">
                  <div class="section-header">
                    <div class="header-left">
                      <div class="header-title">예약 정보</div>
                      <div class="header-caption">
                        [예약번호 <strong>{{ reservationInfo.resveNo }}</strong
                        >]
                      </div>
                    </div>
                  </div>
                  <div class="section-body">
                    <div class="body-data">
                      <div class="data-outer">
                        <div class="data-inner">
                          <ul class="data-content">
                            <li class="field groupName">
                              <!-- 필수 : required -->
                              <div class="title">단체명</div>
                              <div class="content">
                                <ul class="row">
                                  <li class="item form-group">
                                    {{ reservationInfo.grpName }}
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li class="field">
                              <!-- 필수 : required -->
                              <div class="title">연단체</div>
                              <div class="content">
                                <ul class="row">
                                  <li class="item form-group">
                                    {{
                                      commonCodesGetComName(
                                        "GRP_KIND",
                                        reservationInfo.grpKind
                                      )
                                    }}
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li class="field">
                              <!-- 필수 : required -->
                              <div class="title required">예약자명</div>
                              <div class="content">
                                <ul class="row">
                                  <li class="item form-group">
                                    {{ reservationInfo.resveName }}
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li class="field">
                              <!-- 필수 : required -->
                              <div class="title">회원번호</div>
                              <div class="content">
                                <ul class="row">
                                  <li class="item form-group">
                                    {{ reservationInfo.memberNo }}
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li class="field">
                              <!-- 필수 : required -->
                              <div class="title required">회원구분</div>
                              <div class="content">
                                <ul class="row">
                                  <li class="item form-group">
                                    {{
                                      commonCodesGetComName(
                                        "MEMBER_DIV",
                                        reservationInfo.memberDiv
                                      )
                                    }}
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li class="field">
                              <!-- 필수 : required -->
                              <div class="title required">회원등급</div>
                              <div class="content">
                                <ul class="row">
                                  <li class="item form-group">
                                    {{
                                      commonCodesGetComName(
                                        "MEMBER_GRADE",
                                        reservationInfo.memberGrade
                                      )
                                    }}
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li class="field">
                              <!-- 필수 : required -->
                              <div class="title required">연락자명</div>
                              <div class="content">
                                <ul class="row">
                                  <li class="item form-group">
                                    {{ reservationInfo.contactName }}
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li class="field">
                              <!-- 필수 : required -->
                              <div class="title required">연락처</div>
                              <div class="content">
                                <ul class="row">
                                  <li class="item form-group">
                                    {{
                                      getFormattedPhoneNumber(
                                        reservationInfo.contactTel
                                      )
                                    }}
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li class="field">
                              <!-- 필수 : required -->
                              <div class="title required">예약종류</div>
                              <div class="content">
                                <ul class="row">
                                  <li class="item form-group">
                                    {{
                                      commonCodesGetComName(
                                        "RESVE_KIND",
                                        reservationInfo.resveKind
                                      )
                                    }}
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li class="field">
                              <!-- 필수 : required -->
                              <div class="title required">예약채널</div>
                              <div class="content">
                                <ul class="row">
                                  <li class="item form-group">
                                    {{
                                      commonCodesGetComName(
                                        "RESVE_CHANNEL",
                                        reservationInfo.resveChannel
                                      )
                                    }}
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li class="field remarks">
                              <!-- 필수 : required -->
                              <div class="title">비고</div>
                              <div class="content">
                                <ul class="row">
                                  <li
                                    class="item form-group"
                                    v-html="reservationInfo.resveRemarks"
                                  ></li>
                                </ul>
                              </div>
                            </li>
                            <li class="field enrollment">
                              <!-- 필수 : required -->
                              <div class="title">등록</div>
                              <div class="content">
                                <ul class="row">
                                  <li class="item form-group">
                                    {{ reservationInfo.resveInfo }}({{
                                      reservationInfo.insertDt
                                    }})
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li class="field modified">
                              <!-- 필수 : required -->
                              <div class="title">수정</div>
                              <div class="content">
                                <ul class="row">
                                  <li class="item form-group">
                                    {{
                                      reservationInfo.updateName
                                        ? reservationInfo.updateName
                                        : null
                                    }}{{
                                      reservationInfo.updateDt
                                        ? `(${reservationInfo.updateDt})`
                                        : null
                                    }}
                                  </li>
                                </ul>
                              </div>
                            </li>
                          </ul>
                          <div class="border-left"></div>
                          <div class="border-right"></div>
                          <div class="border-top"></div>
                          <div class="border-bottom"></div>
                        </div>
                      </div>
                      <div class="border-left"></div>
                      <div class="border-right"></div>
                      <div class="border-top"></div>
                      <div class="border-bottom"></div>
                    </div>
                  </div>
                </section>
                <!-- 아코디언 : accordion / 닫힘 : close -->
                <section
                  class="article-section section-02"
                  v-if="reservationTrans"
                >
                  <div class="section-header">
                    <div class="header-left">
                      <div class="header-title">위임 정보</div>
                    </div>
                  </div>
                  <div class="section-body">
                    <div class="body-data">
                      <div class="data-outer">
                        <div class="data-inner">
                          <ul class="data-content">
                            <li class="field">
                              <!-- 필수 : required -->
                              <div class="title">위임자명</div>
                              <div class="content">
                                <ul class="row">
                                  <li class="item form-group">
                                    {{ reservationTrans.transName }}
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li class="field">
                              <!-- 필수 : required -->
                              <div class="title">위임 연락처</div>
                              <div class="content">
                                <ul class="row">
                                  <li class="item form-group">
                                    {{
                                      getFormattedPhoneNumber(
                                        reservationTrans.contactTel
                                      )
                                    }}
                                  </li>
                                </ul>
                              </div>
                            </li>
                          </ul>
                          <div class="border-left"></div>
                          <div class="border-right"></div>
                          <div class="border-top"></div>
                          <div class="border-bottom"></div>
                        </div>
                      </div>
                      <div class="border-left"></div>
                      <div class="border-right"></div>
                      <div class="border-top"></div>
                      <div class="border-bottom"></div>
                    </div>
                  </div>
                </section>
                <!-- 아코디언 : accordion / 닫힘 : close -->
                <section class="article-section section-03" v-if="reservationCmpns && reservationCmpns.length > 0">
                  <div class="section-header">
                    <div class="header-left">
                      <div class="header-title">동반자 정보</div>
                    </div>
                  </div>
                  <div class="section-body">
                    <div class="cmpn-body">
                      <div
                        v-for="item in reservationCmpns" :key="item.sno"
                        :class="[
                          'item',
                          item.reprsntFlag && 'representative'
                        ]"
                      >
                        <div class="content">
                          <!-- <div class="no">
                            {{ item.sno }}
                          </div> -->
                          <div
                            v-if="getCmpnAutoCheckedInFlag(item)"
                            class="checked-in"
                          />
                          <div class="name">
                            {{ item.cmpnName }}
                          </div>
                          <div class="grade">
                            {{ getCmpnMemberGrade(item) }}
                          </div>
                          <div
                            v-if="item.contactTel"
                            class="bottom"
                          >
                            {{ getFormattedPhoneNumber(item.contactTel) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <!-- 아코디언 : accordion / 닫힘 : close -->
                <section
                  class="article-section section-04"
                  v-if="reservationAddedInfo"
                >
                  <div class="section-header">
                    <div class="header-left">
                      <div class="header-title">부가 정보</div>
                    </div>
                  </div>
                  <div class="section-body">
                    <div class="body-data">
                      <div class="data-outer">
                        <div class="data-inner">
                          <ul class="data-content">
                            <li class="field">
                              <!-- 필수 : required -->
                              <div class="title">프로모션</div>
                              <div class="content">
                                <ul class="row">
                                  <li class="item form-group">
                                    {{ reservationAddedInfo.promtnName }}
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li class="field">
                              <!-- 필수 : required -->
                              <div class="title">팀그린피</div>
                              <div class="content">
                                <ul class="row">
                                  <li class="item form-group">
                                    {{
                                      reservationAddedInfo.teamGreenFee
                                        | numberWithCommas
                                    }}
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li class="field">
                              <!-- 필수 : required -->
                              <div class="title">셀프캐디</div>
                              <div class="content">
                                <ul class="row">
                                  <li class="item form-group">
                                    {{ reservationAddedInfo.selfFlagCaption }}
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li class="field">
                              <!-- 필수 : required -->
                              <div class="title">조인신청</div>
                              <div class="content">
                                <ul class="row">
                                  <li class="item form-group">
                                    {{ reservationAddedInfo.joinFlagCaption }}
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li class="field">
                              <!-- 필수 : required -->
                              <div class="title">라운드인원</div>
                              <div class="content">
                                <ul class="row">
                                  <li class="item form-group">
                                    {{ reservationAddedInfo.visitCnt }}명
                                  </li>
                                </ul>
                              </div>
                            </li>
                          </ul>
                          <div class="border-left"></div>
                          <div class="border-right"></div>
                          <div class="border-top"></div>
                          <div class="border-bottom"></div>
                        </div>
                      </div>
                      <div class="border-left"></div>
                      <div class="border-right"></div>
                      <div class="border-top"></div>
                      <div class="border-bottom"></div>
                    </div>
                  </div>
                </section>
                <!-- 아코디언 : accordion / 닫힘 : close -->
                <section class="article-section section-05">
                  <div class="section-header">
                    <div class="header-left">
                      <div class="header-title">회원권 정보</div>
                    </div>
                  </div>
                  <link-members
                    :member-link-list="memberLinkList"
                  />
                </section>
              </article>
            </div>
          </div>
        </div>
        <div class="windowFooter">
          <ul class="button">
            <li class="close">
              <erp-button
                  buttonDiv="CLOSE"
                  id="closeButton"
                  @click.native="closeReservationTimeDetailPopup"

              >
                닫기
              </erp-button>
            </li>
          </ul>
        </div>
      </div>
    </ejs-dialog>
  </div>
</template>

<style scoped>
/* 동반자 정보 퍼블리싱 */
body .cmpn-body {display: flex; padding: 10px; border: 1px solid #ccc}
body .cmpn-body > .item {display: flex; flex-direction: column; width: 100px; height: 100px; font-size: 14px; color: #666}
body .cmpn-body > .item:not(:last-child) { margin-right: 15px }
body .cmpn-body > .item > .content,
body .cmpn-body > .item > .bottom {display: flex; align-items: center; justify-content: center; width: inherit; height: inherit}
body .cmpn-body > .item > .content {flex-direction: column; position: relative; font-family: NanumSquare-Regular, serif; border: 1px solid #eaeaea; border-radius: 6px; background-color: #fff}
body .cmpn-body > .item.representative > .content::before {position: absolute; top: -8px; left: 50%; width: 22px; height: 14px; margin-left: -11px; background: transparent url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAAAwCAYAAACynDzrAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDA2IDc5LjE2NDc1MywgMjAyMS8wMi8xNS0xMTo1MjoxMyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo3YjI0OTI5My05MzVjLTI1NGYtOTNkNS0xMjliNjBlMGZjYWQiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OTA4M0YyMEJBODlCMTFFQkI4QzhFQjE2RkQ4RkIyNDciIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OTA4M0YyMEFBODlCMTFFQkI4QzhFQjE2RkQ4RkIyNDciIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OThkOWIwMWEtODE3MC03OTRiLWIyMTctZDc3MGE2YmUzNmE0IiBzdFJlZjpkb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6YTg4MGE0YmUtYWQ3OS01OTQxLWI3MzYtYjAwZTA2YjM3YTRjIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+UTKJiwAAA+pJREFUeNrsm89rE0EUxzdJLdZDLf4oInoQxJOFotBitQVzLEahFgIt9awH8Q8QT8W71oN4KhRaL8FfTZsQtSS26kUo/giICJoqYpGKNeJvrd8nL7Isuzszm51IdvvgdZLM23lvPjv75u02iRiQlfT2jWjOQvuh9Po59CL0fOTQq1+GZoH//WiGoQf4oznoGfi+WwPfMTSnoCegO6FL0BT0NPwvRWCwAW/uQ3fZHD8Bo0HNASbQXIE2WLp+Qvvgf1Kz/3E0AzZdz6D7CNAIXpx0GeMIgryhKbi1aF5AtziYvIXugP+vmvwfRnPdxeRCFH+SgnH6NZ7Abhc4Bvd1a/QvmluSALUKjLZpDHCrTzZeRTS3VgK0KDAqaQyw5JONLv+LBGhMYDShMcA5QZAlttElormNRXl7nXcwmEGCvKkrOoxNO9UQ9ItNN302xDa6/NPcZhy6iclwFEZlvOjhOuijxSiOTD+kuRR5Cl2w+XyB+3Ru8TS3uOXjMrPoITYRywHnuGgyy2/oMRiPawhwM5/B3Q4mT2gC8P1Og+9BTi9RS9cl+DteeWPtzNiM9TdP8YB+BrgeTdYFjsF9GbatBRySW9bJm6XgkA/IbpQLK7/g5KB7JMz3kq1fkHgOow5wKgzsAXHF6pS01tA9SrWQTHA6FA7rYEjNPsBJ8VzspGi9nO0oTrn4qEDq9RjgOjRXFeGYIV3jMbz47hXAIcnbXTqGRB6ygxT3ACcNPVjFIqBj06qQOFYRHDlAWGIvJbbXJg40Lhlgow9wzJAmeUxZOGmOWSQFmRUks4rMkLok4KR8gvOvPuNV3Cjw3aUAp2hXTjgBmpYMtIm34U4BnISGOi/hBoljykjCsb283ADNQj9LDtzMO0ynJUB6UndZExwzpAn2ZYWT49gM3wFhqX1Dc1thcAoki8DaTHCoEOsz9MtRLmRj7LuNC1DVkqCgsoJULrOKtFANhQDbGc6AUTsZYEjtXMe1KB5fdLqdafAREMkm6ANozKi9EKSkR995p46oy6MAupsuenD2P+BU61sdEEvWCIcUvAKaDgGcotvjFBEgetz5KeCAZtw6XQGB7HfF7T5cgBRuO+pVVqB3qgU0FWBAj3CVvK8KEAZ4jeZxQAHlRQZRyYEyq4DCB0iYf1QA0fd0ymHLP9KAMNAPw/LvkDBcXiorKIhVte+AgnRfJpV/lADxdv8wTPlHdQUFaTfLyxquAvIZ0D3ocljyjzIg/jJTvW/30vnHywoKwnavdIK9AKr37T6vFRCW55s63u7p23KzulcQSbpOAc3jBC/XAlA2DJdXNYDoxy8fVgE55yH6iVQu6PmH5I8AAwDRsVdmVOuzLAAAAABJRU5ErkJggg==) no-repeat center center / 22px 14px; content: ''}
body .cmpn-body > .item.representative > .content {color: #fff; border-color: #1f5b41; background-color: #1f5b41}
/*body .cmpn-body > .item > .content > .no {display: flex; align-items: center; justify-content: center; position: absolute; top: -1px; left: -1px; width: 24px; height: 25px; font-weight: bold; color: #fff; border-top-left-radius: 5px; background: red}*/
body .cmpn-body > .item > .content > .checked-in {display: flex; align-items: center; justify-content: center; position: absolute; top: -8px; right: -8px; width: 16px; height: 16px; font-weight: bold; color: #fff; border-radius: 500rem; background-color: #84B7E3; background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAHCAYAAADebrddAAAAAXNSR0IArs4c6QAAADZJREFUKFNjZCAS/P///z8jMWrBCkEAxsClCVkebDIuDejicGegS2AzAMXNMAW4bMLwID4/AACsvCwELJDGBAAAAABJRU5ErkJggg==); background-repeat: no-repeat; background-position: center}
body .cmpn-body > .item > .content > .name {width: 85%; font-weight: bold; text-align: center; text-overflow: ellipsis; overflow: hidden; white-space: nowrap}
body .cmpn-body > .item > .content > .grade {width: 85%; font-size: 12px; text-align: center; text-overflow: ellipsis; overflow: hidden; white-space: nowrap}
body .cmpn-body > .item > .content > .bottom {font-size: 12px}
</style>

<script>
import { getFormattedPhoneNumber } from "@/utils/string";
import {
  commonCodesGetComName,
  commonCodeGetComCodeByCurrentBizCode,
} from "@/utils/commonCodes";
import confirmDialogMixin from "@/views/layout/mixin/messagePopupDialogMixin";
import ErpButton from "@/components/button/ErpButton.vue";
// 연계회원 component
import LinkMembers from "@/views/common/LinkMembers";

import GolfErpAPI from "@/api/v2/GolfErpAPI";
import { numberWithCommas } from "@/utils/number";

export default {
  name: "reservationTimeDetailPopup",
  mixins: [confirmDialogMixin],
  components: {
    LinkMembers,
    ErpButton
  },
  filters: {
    numberWithCommas,
  },
  data() {
    return {
      resveNo: null,
      timeId: null,
      reservationTimeLists: [],
      reservationInfo: {},
      reservationTrans: {},
      reservationCmpns: [],
      visitors: [],
      reservationAddedInfo: {},
      memberLinkList: [],
      selectedRow: null,
      memberDivOptions: commonCodeGetComCodeByCurrentBizCode("MEMBER_DIV"),
    };
  },
  methods: {
    getFormattedPhoneNumber,
    commonCodesGetComName,
    getCmpnAutoCheckedInFlag({ cmpnName, contactTel }) {
      return this.visitors
        ?.find(item => item.name === cmpnName && item.contactNumber === contactTel)
        ?.isAutoCheckIn;
    },
    getCmpnMemberGrade(item) {
      const memberGrade = item?.memberGrade;
      return memberGrade
        ? `(${commonCodesGetComName('MEMBER_GRADE', memberGrade)})`
        : '(비회원)';
    },
    async showReservationTimeDetailPopup(resveNo, timeId) {
      this.resveNo = resveNo;
      this.timeId = timeId;

      await this.getReservationDetailAPI();
    },
    onReservationTimeDetailPopupClosed() {
      this.$emit("popupClosed");
    },
    closeReservationTimeDetailPopup() {
      this.$refs.reservationTimeDetailPopup.hide();
    },
    async getReservationDetailAPI() {
      const {data: {reservationDetails},} = await GolfErpAPI.fetchReservationTimesDetail({timeId: this.timeId, resveNo: this.resveNo,});
      console.log(reservationDetails,this.timeId,this.resveNo);
      const reservationDetailFiltered = reservationDetails.filter(
        (detailInfo) => detailInfo.timeId.toString() == this.timeId
      );
      if (reservationDetailFiltered.length === 1) {
        const reservationDetail = reservationDetailFiltered[0];

        this.reservationInfo = {
          ...reservationDetail.reservationConfirm?.reservationMember,
          resveRemarks: reservationDetail.reservationConfirm?.reservationMember?.resveRemarks?.replace(
            /(\r\n|\n|\r)/g,
            "<br />"
          ),
          insertName: reservationDetail.insertName,
          insertDt:
          reservationDetail.reservationConfirm?.reservationMember?.insertDt,
          updateName: reservationDetail.updateName,
          updateDt:
          reservationDetail.reservationConfirm?.reservationMember?.updateDt,
        };
        this.reservationTrans = reservationDetail.reservationConfirm?.reservationTrans;
        this.reservationCmpns = reservationDetail.reservationConfirm?.reservationCmpns;
        this.visitors = reservationDetail.reservationConfirm?.team?.visitors;
        this.reservationAddedInfo = {
          promtnName: reservationDetail.reservationPromotion?.promtnName,
          teamGreenFee: reservationDetail.reservationConfirm?.teamGreenFee,
          selfFlagCaption: reservationDetail.reservationConfirm?.selfFlag ? "예" : "아니오",
          joinFlagCaption: reservationDetail.reservationConfirm?.joinFlag ? "예" : "아니오",
          visitCnt: reservationDetail.reservationConfirm?.visitCnt,
        };
        this.memberLinkList = reservationDetail.reservationConfirm?.reservationMember?.reservationLinkMembers;
      } else {
        this.errorToast("예약 정보가 없습니다");
      }
    },
  },
};
</script>
